/** Tekst do porównań: małe litery, bez polskich znaków („Dziś” ~ „dzis”, „Łódź” ~ „lodz”). */
export function normalizeText(text: string): string {
  return text
    .toLocaleLowerCase('pl-PL')
    .replaceAll('ł', 'l')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim();
}

/**
 * Filtr dla cmdk: 1 = zaczyna się od frazy, 0.8 = słowo zaczyna się od frazy, 0.5 = zawiera, 0 = brak.
 * Każde słowo frazy musi pasować (kolejność dowolna).
 */
export function commandFilter(value: string, search: string, keywords?: string[]): number {
  const haystack = normalizeText([value, ...(keywords ?? [])].join(' '));
  const phrase = normalizeText(search);
  const terms = phrase.split(/\s+/).filter(Boolean);
  if (terms.length === 0 || haystack.startsWith(phrase)) return 1;
  let score = 1;
  for (const term of terms) {
    if (haystack.startsWith(term)) continue;
    if (haystack.split(/[\s·,./-]+/).some((word) => word.startsWith(term))) {
      score = Math.min(score, 0.8);
      continue;
    }
    if (haystack.includes(term)) {
      score = Math.min(score, 0.5);
      continue;
    }
    return 0;
  }
  return score;
}
